module.exports = __webpack_public_path__ + "static/LogoWhite-e574627840cdf9b40605d9d1205def55.svg";